export default function DialogueForm({
  isOpen,
  title = "Dialog Title",
  content = "Dialog content goes here.",
  onConfirm,
  onCancel,
}) {
  const handleOutsideClick = (e) => {
    if (e.target.id === "dialog-overlay") onCancel?.();
  };

  if (!isOpen) return null;

  return (
    <div
      id="dialog-overlay"
      onMouseDown={handleOutsideClick}
      className="fixed inset-0 z-40 backdrop-blur-sm bg-black/30 flex items-center justify-center"
    >
      <div
        className="bg-white dark:bg-neutral-900 shadow-xl rounded-2xl p-6 max-w-md w-full mx-4"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-2">{title}</h2>
        <p className="text-base text-neutral-700 dark:text-neutral-300 mb-6">{content}</p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-xl bg-neutral-200 dark:bg-neutral-700 hover:bg-neutral-300 dark:hover:bg-neutral-600 transition"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}